"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKMenuGroup = void 0;
/* eslint-disable jsx-a11y/role-has-required-aria-props */
/* eslint-disable jsx-a11y/aria-activedescendant-has-tabindex */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/role-supports-aria-props */
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var models_1 = require("../../../models");
var GKMenuItem_1 = require("../GKMenuItem/GKMenuItem");
var GKMenuLoading_1 = require("../GKMenuLoading/GKMenuLoading");
/**
 * Grouping within a GKMenu. Can itself contain GKMenuItems and/or GKMenuGroups. Generic type parameter T referrs to the type
 * of any of GKMenuItems' data payload(s), G is the payload type for the group itself.
 */
var GKMenuGroup = /** @class */ (function (_super) {
    __extends(GKMenuGroup, _super);
    function GKMenuGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.groupUlId = _this.uniqueId + "-group-container";
        _this.headingRef = React.createRef();
        // PUBLIC API ---------------------
        /** Sets the group to be virtually focused (for ARIA purposes) */
        _this.setVirtualFocus = function (value) {
            _this.setState({ hasVirtualFocus: value });
        };
        // PRIVATE METHODS -----------------
        _this.processChildren = function () {
            var filteredChildren = React.Children.toArray(_this.props.children).filter(function (c) {
                return c.type === GKMenuGroup || c.type === GKMenuItem_1.GKMenuItem;
            });
            var itemRefs = [];
            var clonedChildren = filteredChildren.map(function (item) {
                return React.cloneElement(item, {
                    disabled: _this.props.disabled || item.props.disabled,
                    ref: function (ref) {
                        if (!item.props.disabled) {
                            itemRefs.push(ref);
                        }
                    },
                });
            });
            _this.pvtNavigator = new models_1.GroupNavigator(itemRefs, {
                onLeave: _this.onLeave,
            });
            _this.setState({ menuGroupItems: clonedChildren });
        };
        _this.onLeave = function () {
            if (_this.state.activeItem) {
                _this.state.activeItem.setVirtualFocus(false);
            }
            _this.setState({ activeItem: null });
        };
        _this.onClick = function (e) {
            if (_this.props.onSelect) {
                var selfClicked = Boolean(_this.headingRef.current &&
                    _this.headingRef.current.contains(e.target));
                _this.props.onSelect(_this.props.payload, selfClicked);
            }
        };
        _this.state = {
            activeItem: null,
            hasVirtualFocus: false,
            menuGroupItems: [],
        };
        return _this;
    }
    Object.defineProperty(GKMenuGroup.prototype, "navigator", {
        get: function () {
            return this.pvtNavigator;
        },
        enumerable: false,
        configurable: true
    });
    // COMPONENT LIFECYCLE -----------
    GKMenuGroup.prototype.componentDidMount = function () {
        this.processChildren();
    };
    GKMenuGroup.prototype.componentDidUpdate = function (oldProps) {
        if (oldProps.children !== this.props.children) {
            this.processChildren();
            this.setState({ activeItem: null, hasVirtualFocus: false });
        }
    };
    GKMenuGroup.prototype.render = function () {
        // If we don't destructure onSelect, then the li's onClick method has a type error
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _a = this.props, isLoading = _a.isLoading, label = _a.label, onSelect = _a.onSelect, otherProps = __rest(_a, ["isLoading", "label", "onSelect"]);
        var _b = this.state, activeItem = _b.activeItem, hasVirtualFocus = _b.hasVirtualFocus, menuGroupItems = _b.menuGroupItems;
        return (React.createElement(React.Fragment, null,
            React.createElement("li", __assign({}, (0, common_1.mapDefaultProps)(otherProps, {
                _gkComponentName: "gk-menu-group",
                className: "" + (hasVirtualFocus ? "gk-has-virtual-focus" : ""),
                id: this.uniqueId,
            }), { "aria-activedescendant": this.groupUlId, onClick: this.onClick }),
                React.createElement("div", { role: "heading", className: "gk-menu-group-title", ref: this.headingRef }, label),
                React.createElement("ul", { id: this.groupUlId, "aria-activedescendant": activeItem ? activeItem.uniqueId : undefined, role: "group" }, menuGroupItems)),
            React.createElement(GKMenuLoading_1.GKMenuLoading, { isLoading: isLoading })));
    };
    return GKMenuGroup;
}(common_1.GKPureComponent));
exports.GKMenuGroup = GKMenuGroup;
